import { ArrowLeftIcon, ArrowRightIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../../../factory/factory.utils.mjs';
import { Box } from '../../../../Other/Box/Box.mjs';
import classes from './SliderControl.module.css.mjs';

const SliderControl = polymorphicFactory(
  (props, ref) => {
    const { component = "button", className, direction, isOnPhoto = false, ...rest } = props;
    const classNames = clsx(
      "kohler-slider-control-root",
      className,
      classes.sliderControl,
      isOnPhoto ? classes.sliderControlOnPhoto : classes.sliderControlDefault
    );
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        "aria-label": rest["aria-label"] || direction === "left" ? "carousel arrow left" : "carousel arrow right",
        ...rest
      },
      direction === "left" ? /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: true, size: isOnPhoto ? "medium" : "small" }) : /* @__PURE__ */ React.createElement(ArrowRightIcon, { withBoundingBox: true, size: isOnPhoto ? "medium" : "small" })
    );
  }
);

export { SliderControl };
